/*
 * Product page photos: previous / next on the large desktop photo, and the same gentle change on
 * the phone and tablet slider. One photo at a time: the next photo fades in softly with the house
 * fade (480ms, gentle curve). Nothing slides, nothing overlaps. Instant for reduced-motion visitors.
 * Kept outside main-product.liquid.
 */
(() => {
  if (window.ArnavGalleryNav) return;

  // The house fade used in the header and footer: 480ms on the gentler standard curve.
  const FADE = '480ms cubic-bezier(.22, .68, .2, 1)';

  const STYLE = `
.arnav-gallery-nav{position:absolute;top:50%;transform:translateY(-50%);z-index:25;width:44px;height:44px;display:flex;align-items:center;justify-content:center;background:none;border:0;border-radius:0;padding:0;margin:0;cursor:pointer;color:#1A1A1A;filter:drop-shadow(0 2px 4px rgba(0,0,0,.4));transition:opacity .2s ease}
.arnav-gallery-nav:hover{opacity:.7}
.arnav-gallery-nav:focus-visible{outline:1px solid #a68148;outline-offset:2px}
.arnav-gallery-nav svg{width:24px;height:24px;display:block}
.arnav-gallery-nav--prev{left:12px}
.arnav-gallery-nav--next{right:12px}
@keyframes arnav-photo-in{from{opacity:0}to{opacity:1}}
.mobile-media-slider .mobile-slide-item.slide-in-right,.mobile-media-slider .mobile-slide-item.slide-in-left{animation:arnav-photo-in ${FADE} both!important;transform:none!important}
@media (prefers-reduced-motion:reduce){.mobile-media-slider .mobile-slide-item.slide-in-right,.mobile-media-slider .mobile-slide-item.slide-in-left{animation:none!important}}`;

  const reducedMotion = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const icon = (d) =>
    `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="${d}"/></svg>`;

  // Shopify image URLs carry the size as width=N; the same photo at another size.
  const sized = (src, w) => (/[?&]width=\d+/.test(src) ? src.replace(/([?&]width=)\d+/, `$1${w}`) : `${src}${src.includes('?') ? '&' : '?'}width=${w}`);

  function addStyle() {
    if (document.getElementById('arnav-gallery-nav-style')) return;
    const s = document.createElement('style');
    s.id = 'arnav-gallery-nav-style';
    s.textContent = STYLE;
    document.head.appendChild(s);
  }

  function setupDesktop(stack) {
    const main = stack.querySelector('.media-item.media-full-width');
    const img = main && main.querySelector('img[id^="PrimaryProductImage-"]');
    if (!main || !img || main.querySelector('.arnav-gallery-nav, [data-desktop-media-nav]')) return;
    const list = [...stack.querySelectorAll('[data-lightbox-trigger][data-media-src]')]
      .map((el) => el.getAttribute('data-media-src'))
      .filter((src, i, all) => src && all.indexOf(src) === i);
    if (list.length < 2) return;

    // Every photo is fetched once the page has loaded, so a click never waits.
    const warm = () =>
      list.forEach((src) => {
        const pre = new Image();
        pre.src = sized(src, 1400);
      });
    if (document.readyState === 'complete') setTimeout(warm, 300);
    else addEventListener('load', () => setTimeout(warm, 300), { once: true });

    let index = 0;
    let shown = 0;
    const show = (step) => {
      index = (index + step + list.length) % list.length;
      const target = index;
      const src = list[target];
      main.setAttribute('data-media-src', sized(src, 1400));
      const next = new Image();
      next.src = sized(src, 1400);
      (next.decode ? next.decode().catch(() => {}) : Promise.resolve()).then(() => {
        if (target !== index || target === shown) return; // a later click wins
        shown = target;
        img.removeAttribute('srcset');
        img.style.transition = 'none';
        if (!reducedMotion()) img.style.opacity = '0';
        img.src = next.src;
        if (reducedMotion()) return;
        void img.offsetWidth;
        img.style.transition = `opacity ${FADE}, transform .4s ease`;
        img.style.opacity = '1';
      });
    };
    const button = (dir, label, path) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = `arnav-gallery-nav arnav-gallery-nav--${dir}`;
      b.setAttribute('aria-label', label);
      b.innerHTML = icon(path);
      b.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        show(dir === 'prev' ? -1 : 1);
      });
      return b;
    };

    addStyle();
    main.append(button('prev', 'Previous image', 'M15 18l-6-6 6-6'), button('next', 'Next image', 'M9 18l6-6-6-6'));
    main.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.preventDefault();
        show(e.key === 'ArrowLeft' ? -1 : 1);
      }
    });
  }

  // Phone and tablet: the theme's slider keeps working as it is; its slide-in is replaced by the
  // same soft fade, and every photo is fetched after load so the next one is never blank.
  function setupPhone(slider) {
    addStyle();
    const eager = () =>
      slider.querySelectorAll('.mobile-slide-item img[loading="lazy"]').forEach((img) => {
        img.loading = 'eager';
      });
    if (document.readyState === 'complete') eager();
    else addEventListener('load', eager, { once: true });
  }

  function init(scope = document) {
    scope.querySelectorAll('.primary-media-stack').forEach(setupDesktop);
    scope.querySelectorAll('.mobile-media-slider').forEach(setupPhone);
  }

  window.ArnavGalleryNav = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
